import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: _ctx.disabled,
    class: _normalizeClass(["btn", [_ctx.colorClass, _ctx.sizeClass, _ctx.shadowClass, { 'is-disabled': _ctx.disabled }]]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, _toDisplayString(_ctx.text), 11, _hoisted_1))
}